import "./materias.css";
import { useState, useEffect } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import { useNavigate } from "react-router-dom";
import Postagem from "../../components/postagem/postagem.jsx";
import Swal from "sweetalert2";

function Materias() {
  const [materias, setMaterias] = useState([]);
  const [open, setOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);

  const [titulo, setTitulo] = useState("");
  const [subtitulo, setSubtitulo] = useState("");
  const [texto, setTexto] = useState("");
  const [img, setImg] = useState(null);

  const [visibleCount, setVisibleCount] = useState(10);
  const navigate = useNavigate();

  /* ================== BUSCAR MATÉRIAS (ADMIN) ================== */
  useEffect(() => {
    async function fetchMaterias() {
      try {
        const response = await api.get("/admin/materias");
        setMaterias(response.data || []);
      } catch (error) {
        console.log(error.response?.data?.error);
      }
    }
    fetchMaterias();
  }, []);

  /* ================== ATUALIZAR MATÉRIA (ativo / ordem) ================== */
  function atualizarMateria(id, dados) {
    setMaterias(prev =>
      prev.map(m =>
        m.id_materia === id ? { ...m, ...dados } : m
      )
    );
  }

  /* ================== ORDENAR ================== */
  const materiasOrdenadas = [...materias].sort((a, b) => {
    if (a.ativo !== b.ativo) return a.ativo ? -1 : 1;

    if (a.ativo && b.ativo) {
      if (a.ordem == null && b.ordem == null) return 0;
      if (a.ordem == null) return 1;
      if (b.ordem == null) return -1;
      return a.ordem - b.ordem;
    }

    return 0;
  });

  /* ================== MODAL ================== */
  function abrirModal() {
    setTitulo("");
    setSubtitulo("");
    setTexto("");
    setImg(null);
    setEditandoId(null);
    setOpen(true);
  }

  function editarPostModal(materia) {
    setTitulo(materia.titulo);
    setSubtitulo(materia.subtitulo || "");
    setTexto(materia.texto);
    setImg(materia.imagem_url);
    setEditandoId(materia.id_materia);
    setOpen(true);
  }

  /* ================== EXCLUIR ================== */
async function excluirPost(id_materia) {
  const result = await Swal.fire({
    title: "Tem certeza?",
    text: "Esta matéria será excluída permanentemente.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, excluir",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#e53935",
    cancelButtonColor: "#64748b",
  });

  if (!result.isConfirmed) return;

  try {
    await api.delete(`/materias/${id_materia}`);

    // 🔥 remove do estado imediatamente
    setMaterias(prev =>
      prev.filter(m => m.id_materia !== id_materia)
    );

    Swal.fire({
      icon: "success",
      title: "Matéria excluída!",
      timer: 1200,
      showConfirmButton: false,
    });
  } catch (error) {
    Swal.fire(
      "Erro",
      error.response?.data?.error || "Erro ao excluir matéria",
      "error"
    );
  }
}

  /* ================== INSERIR ================== */
  async function enviarPost() {
    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("subtitulo", subtitulo);
    formData.append("texto", texto);
    if (img) formData.append("imagem_url", img);

    const response = await api.post("/materias", formData);
    setMaterias(prev => [response.data, ...prev]);
    setOpen(false);
  }

  /* ================== EDITAR ================== */
  async function enviarEdit() {
    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("subtitulo", subtitulo);
    formData.append("texto", texto);
    if (img && typeof img !== "string") {
      formData.append("imagem_url", img);
    }

    const response = await api.put(
      `/materias/${editandoId}`,
      formData
    );

    setMaterias(prev =>
      prev.map(m =>
        m.id_materia === editandoId ? response.data : m
      )
    );
    setOpen(false);
  }

  /* ================== NAVEGAÇÃO ================== */
  function abrirPost(id) {
    navigate(`/materias/${id}`);
  }

  function voltar() {
    navigate("/home");
  }

  function verMais() {
    setVisibleCount(prev => prev + 10);
  }

  /* ================== RENDER ================== */
  return (
    <div className="container-materias">
      <div className="header-materias">
        <h2>Matérias</h2>
        <div className="containerBtn-materias">
          <button className="inserir" onClick={abrirModal}>
            Nova Matéria
          </button>
          <BtnVoltar voltar={voltar} />
        </div>
      </div>

      <div className="materias">
        {materiasOrdenadas
          .slice(0, visibleCount)
          .map(materia => (
            <Postagem
              key={materia.id_materia}
              post={materia}
              tipo="materia" 
              abrirPost={abrirPost}
              excluirPost={excluirPost}
              editarPost={editarPostModal}
              atualizarPost={atualizarMateria}
            />
          ))}
      </div>

      {visibleCount < materias.length && (
        <div className="btn-vermais">
          <button onClick={verMais}>Ver mais</button>
        </div>
      )}

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={editandoId ? enviarEdit : enviarPost}
        tipo="materia"
        titulo={titulo}
        setTitulo={setTitulo}
        subtitulo={subtitulo}
        setSubtitulo={setSubtitulo}
        texto={texto}
        setTexto={setTexto}
        img={img}
        setImg={setImg}
      />
    </div>
  );
}

export default Materias;
